

<ng-container *ngIf="variant === 'navbar-vertical'">
    <navbar-vertical></navbar-vertical>
</ng-container>
